import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '..';

import { useAppSelector } from '../../hooks/useRedux';
import { formatStringsToPlural } from '../../utils';
import type { CounterInputLabelData } from './types';

interface ICounterInputLabelProps {
  labelData: CounterInputLabelData;
  isMenuOpen: boolean;
  onToggle: () => void;
}

const CounterInputLabel = ({ labelData, isMenuOpen, onToggle, ...props }: ICounterInputLabelProps) => {
  const { t } = useTranslation();
  const { isMobile } = useAppSelector(({ generics }) => ({
    isMobile: generics.isMobile,
  }));

  return (
    <button className="counter-input-label-container" type="button" onClick={onToggle} {...props}>
      <Icon className="counter-input-label-icon" icon="hotel" round />
      <span className="counter-input-label-text">
        {t('counterInput.label', {
          travelers: formatStringsToPlural('viajante', labelData.travelers),
          rooms: formatStringsToPlural('quarto', labelData.rooms),
        })}
      </span>

      <Icon
        className={`counter-input-label-arrow ${isMenuOpen ? 'open' : ''}`.trim()}
        icon={isMobile ? 'keyboard_arrow_right' : 'arrow_drop_down'}
        round
      />
    </button>
  );
};

export default CounterInputLabel;
